import { useTranslation } from "react-i18next";

const stats = [
  { key: "stats.resources", value: "100+" },
  { key: "stats.categories", value: "14" },
  { key: "stats.guides", value: "60+" },
  { key: "stats.languages", value: "4" },
];

export default function Stats() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.key}
              className="flex flex-col items-center justify-center rounded-2xl border border-background-200 bg-background-100 px-4 py-6 text-center"
            >
              <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">
                {stat.value}
              </span>
              <span className="mt-2 text-xs md:text-sm font-semibold text-foreground-600">
                {t(stat.key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}